import { combineStorage } from '@atlassian/jira-common-storage-redux/src/config.tsx';
import type { State } from '../../../state/types.tsx';
import creationPreferences from './creation-preferences.tsx';
import highlightedVersions from './highlighted-versions.tsx';
import listWidth from './list-width.tsx';

export default combineStorage<State>(creationPreferences, listWidth, highlightedVersions);
